var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',[(_vm.$route.meta && _vm.$route.meta.auth)?_c('navbar'):_vm._e(),_c('v-main',{staticClass:"py-5 primary"},[_c('router-view')],1),_c('footerr'),_c('div',{staticClass:"foot-bootom darkPrimary white--text d-flex align-center justify-center py-3"},[_c('span',[_vm._v("all rights reserved to studyblood")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }